<template> 
  <section class="calling-process-screen">
    <div class="process-content">
      <span class="img-heading">
        <img src="images/its-a-match.png" alt="">
      </span>
      <div class="find-content">
        <span class="pulse"><img :src='require("../../assets/images/image-1.png")' alt=""></span>
      </div>
      <span class="Connecting" v-if="(internetDisconnect || showReconnect)">{{$t('Re-connecting')}}</span>
      <span v-if="(!internetDisconnect && (callStatus === 'call_received'))">{{$t('Calling')}}</span>
    </div>
    <div class="calling-tools">
      <div :class="(first_caller_id === $cookie.get('X-Auth-Id')) ? 'inner' : 'make-center'">
        <span :class="(declineBtn || internetDisconnect || showReconnect) ? 'call-btn disable' : 'call-btn'" @click="callDecline">
          <img :src='require("../../assets/images/call-btn.svg")' alt="">
        </span>
        <span :class="(disconnectBtn || internetDisconnect || showReconnect)? 'call-btn call-accept disable' : 'call-btn call-accept'" @click="callAccept" v-if="(first_caller_id === $cookie.get('X-Auth-Id')) && !internetDisconnect">
          <img :src='require("../../assets/images/accept_call.svg")' alt="">
        </span>
      </div>
    </div>
  </section>
</template>
<script> 
export default {
  name: "CallMatch",
  data(){
    return{
      checked: false,
      disconnectBtn: false,
      disconnectBtn: false,
      declineBtn: false,
    }
  },
  props:{
    identifier: Number,
    first_caller_id: String,
    internetDisconnect: Boolean,
    showReconnect: Boolean,
    callStatus: String
  },
  methods:{
      callDecline(){
       this.declineBtn = true
       this.$emit('callDecline')
      },
      callAccept(){
        this.disconnectBtn = true
        this.$emit('callAccept')
      }
  },
}
</script>